import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnInit,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from "@angular/core";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { ControlContainer, NgForm, UntypedFormGroup } from "@angular/forms";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
@Component({
  selector: "form-control-model",
  templateUrl: "form-control-model.component.html",
  styleUrls: ["form-control-model.component.scss"],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormControlModelComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() columns: Array<form_control>;
  @Input() _columns: Array<form_control>;
  @Input() model: any;
  @Input() public isShowModal: boolean = true;
  @Input() public group: UntypedFormGroup;
  @Input() hasDefault: boolean;
  @Input() defaultHeight: number;
  @Input() hasfocus: string;
  @Input() hasCheckBoxLookUpTree: boolean = true;
  @Input() filterLookUp: any[] = [];
  @Output() valueChange = new EventEmitter<any>();
  @Output() valueChangeByApiName = new EventEmitter<any>();
  @Output() onRowSelected = new EventEmitter<any>();
  @Output() onRowsSelected = new EventEmitter<any>();
  @Output() valueChangeWithName = new EventEmitter<any>();
  @Output() CompleteData = new EventEmitter<any>(true);

  groupColumns: any;
  public FormControlTypes = FormControlTypes;
  public isFloat: number;

  get stylestring(): string {
    return `height:${this.defaultHeight + 0.7}px;margin-bottom:${this.defaultHeight - 20}px`;
  }

  constructor(private cd: ChangeDetectorRef) {}

  change(newValue: any) {
    this.valueChange.emit(newValue);
    this.cd.markForCheck();
  }

  ngOnInit(): void {
    if (this._columns && !this.columns) this._columns = this.columns;
    this.columns = this.columns ? this.columns.filter((x) => x.formVisible) : [];
    this.columns.forEach((x) => {
      if (!x.isFloat) x.isFloat = 0;
    });
    this.groupColumns = this.groupBy(this.columns, "columnNumber");
    for (var i = 1; i < this.groupColumns?.length; i++) {
      if (Number(this.groupColumns[i].key) - Number(this.groupColumns[i - 1].key) !== 1) {
        const diff = Number(this.groupColumns[i].key) - Number(this.groupColumns[i - 1].key);
        for (var j = 1; j < diff; j++) {
          this.groupColumns.push({ key: (i + j).toString(), value: null });
        }
        this.groupColumns = this.groupColumns.sort(function (a, b) {
          return a.key - b.key;
        });
      }
    }

    this.groupColumns.forEach((element) => {
      for (let index = 0; index < element?.value?.length; index++) {
        element.value[index].tabOrder = index + 1;
      }
    });
    this.cd.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["columns"] && this.columns) {
      this.groupColumns = this.groupBy(this.columns, "ColumnNumber");
      for (var i = 1; i < this.groupColumns?.length; i++) {
        if (Number(this.groupColumns[i].key) - Number(this.groupColumns[i - 1].key) !== 1) {
          const diff = Number(this.groupColumns[i].key) - Number(this.groupColumns[i - 1].key);
          for (var j = 1; j < diff; j++) {
            this.groupColumns.push({ key: (i + j).toString(), value: null });
          }
          this.groupColumns = this.groupColumns.sort(function (a, b) {
            return a.key - b.key;
          });
        }
      }
    }
  }

  ngAfterViewInit(): void {
    this.defaultHeight = this.defaultHeight ?? 40;

    if (this.columns.some((s) => s.name === this.hasfocus)) {
      const focusEle = this.columns.find((f) => f.name === this.hasfocus);
      if (focusEle) {
        const findFocusElement = <HTMLInputElement>document.getElementById(focusEle.name);
        if (findFocusElement) findFocusElement.focus();
      }
    }
    this.cd.markForCheck();
  }

  groupBy(value: Array<any>, field: string): Array<any> {
    const groupedObj = value.reduce((prev, cur) => {
      if (!prev[cur[field]]) {
        prev[cur[field]] = [cur];
      } else {
        prev[cur[field]].push(cur);
      }
      return prev;
    }, {});
    return Object.keys(groupedObj).map((key) => ({
      key,
      value: groupedObj[key],
    }));
  }
}
